import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/texts';
import { TEXTS as POINT_TEXTS } from 'application/pages/PointsPage/renderer/texts';

interface ModalTitleProps {
  isAcceptanceAdvancedNull: boolean;
  canAddPointWithPayment?: boolean;
  isPointPage: boolean;
}

const ModalTitle: FC<ModalTitleProps> = ({ isAcceptanceAdvancedNull, canAddPointWithPayment, isPointPage }) => {
  if (isAcceptanceAdvancedNull) {
    return <div />;
  }

  if (canAddPointWithPayment) {
    return <div>{POINT_TEXTS.POINT_CREATE_WITH_PAYMENT_TITLE}</div>;
  }

  if (isPointPage) {
    return <div>{POINT_TEXTS.POINT_CREATE_TITLE}</div>;
  }

  return <div>{TEXTS.POINT_CREATE_TITLE}</div>;
};

export default memo(ModalTitle);
